<template>
  <div :isNonStickyVariantProp="isNewHomeBtnVariant" :qrOrderFlow="qrOrderFlow">
    <div
      class="col-sm-12 location-message-banner pd12 flex-row mb16"
      id="location-message-banner-id"
      v-if="!isLocationPermissionGiven && !qrOrderFlow"
    >
      <span class="location-icon mr8 flex-column">
        <i class="jfi-location fs-17"></i>
      </span>
      <span class="location-nudge-message lh16">{{ textMessage }}</span>
      <button @click="detectGeoLocationPopup" class="line-btn sm">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import setEvents from "../helpers/events";

export default {
  name: "LocationMessageBanner",

  components: {},

  data() {
    return {
      cachedComponentOffsetTop: 0,
      removeSticky: false,
      textMessage: "Give us your exact location for seamless delivery",
      qrOrder: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", () => {
      this.watchSticky();
    });
    this.eventFunction();
  },

  destroyed() {
    window.removeEventListener("scroll", this.watchSticky);
  },

  computed: {
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    isNewHomeBtnVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        this.removeSticky = true;
        return true;
      } else {
        this.removeSticky = false;
        return false;
      }
    },
    isLocationPermissionGiven() {
      return this.$store.state.Location.isLocationPermissionGiven;
    },
    buttonText() {
      return this.isLocationPermissionGiven
        ? "Use current location"
        : "Detect location";
    },
    qrOrderFlow() {
      return this.$store.state.Auth.qrOrder;
    },
  },

  methods: {
    watchSticky() {
      if (this.removeSticky) {
        return;
      }

      let componentRef = document.getElementById("location-message-banner-id");
      if (!componentRef) return;
      if (!this.cachedComponentOffsetTop && componentRef.offsetTop > 0) {
        this.cachedComponentOffsetTop = componentRef.offsetTop;
      }
      if (window.pageYOffset >= this.cachedComponentOffsetTop) {
        componentRef.classList.add("watch-sticky");
      } else {
        componentRef.classList.remove("watch-sticky");
      }
    },
    detectGeoLocationPopup() {
      this.$store.dispatch(keyMapsAction.DETECT_GEO_LOCATION_POPUP, {
        source: "locationPopupBanner",
        showModalM: () => this.showModalM(),
      });
      this.eventFunction(true);
    },
    showModalM() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true,
      );
    },
    eventFunction(isClicked = false) {
      const userAction = isClicked
        ? "Locationbar_Click"
        : "Locationbar_Impression";
      const preEventObj = {
        category: isClicked ? this.buttonText : this.textMessage,
      };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "locationBar",
        2,
        preEventObj,
      );
      setEvents("amplitude", userAction, eventObj);
    },
  },
};
</script>

<style scoped></style>
